import { render, staticRenderFns } from "./SystemConfig.vue?vue&type=template&id=6926c97a&scoped=true"
import script from "./SystemConfig.vue?vue&type=script&lang=js"
export * from "./SystemConfig.vue?vue&type=script&lang=js"
import style0 from "./SystemConfig.vue?vue&type=style&index=0&id=6926c97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6926c97a",
  null
  
)

export default component.exports